import { rivermeadowApi } from './api';

export const usersApi = rivermeadowApi.injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: (organizationId) => ({
                url: `/organizations/${organizationId}/users`,
                method: 'GET',
            }),
            providesTags: ['USERS'],
        }),
    }),
});

export const { useGetUsersQuery, useLazyGetUsersQuery } = usersApi;
